export default __webpack_public_path__ + "static/media/icons-project-photo.cf111709.svg";